/**
 * Custom JS - Collection Filters
 * Handles: price slider, mobile filter sidebar
 * All filters (availability, type, vendor, tags) use <a> links built in Liquid
 */

(function() {
  'use strict';

  const CollectionFilters = {
    init: function() {
      this.filtersContainer = document.querySelector('.productgrid--sidebar [data-collection-filters]');
      this.mobileSidebar = document.querySelector('[data-mobile-filter-sidebar]');

      this.initMobileFilterSidebar();

      if (!this.filtersContainer) return;

      this.initPriceSliders();
      this.bindMobileEvents();
    },

    /* Price range sliders */
    initPriceSliders: function() {
      var self = this;

      document.querySelectorAll('[data-price-filter]').forEach(function(priceFilter) {
        var sliderMin = priceFilter.querySelector('[data-price-slider-min]');
        var sliderMax = priceFilter.querySelector('[data-price-slider-max]');
        var minInput = priceFilter.querySelector('[data-price-min-input]');
        var maxInput = priceFilter.querySelector('[data-price-max-input]');
        var applyBtn = priceFilter.querySelector('[data-price-apply]');

        if (!sliderMin || !sliderMax) return;

        var rangeMin = parseInt(priceFilter.dataset.rangeMin) || 0;
        var rangeMax = parseInt(priceFilter.dataset.rangeMax) || 100000;
        var gap = Math.max(1, Math.floor((rangeMax - rangeMin) * 0.02));

        self.updatePriceRange(priceFilter);

        sliderMin.addEventListener('input', function() {
          var minVal = parseInt(sliderMin.value);
          var maxVal = parseInt(sliderMax.value);
          if (minVal > maxVal - gap) {
            sliderMin.value = maxVal - gap;
          }
          if (minInput) minInput.value = sliderMin.value;
          self.updatePriceRange(priceFilter);
        });

        sliderMax.addEventListener('input', function() {
          var minVal = parseInt(sliderMin.value);
          var maxVal = parseInt(sliderMax.value);
          if (maxVal < minVal + gap) {
            sliderMax.value = minVal + gap;
          }
          if (maxInput) maxInput.value = sliderMax.value;
          self.updatePriceRange(priceFilter);
        });

        if (minInput) {
          minInput.addEventListener('input', function() {
            var val = parseInt(minInput.value) || rangeMin;
            val = Math.max(rangeMin, Math.min(val, rangeMax));
            sliderMin.value = val;
            self.updatePriceRange(priceFilter);
          });
          minInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              self.submitPrice(priceFilter);
            }
          });
        }

        if (maxInput) {
          maxInput.addEventListener('input', function() {
            var val = parseInt(maxInput.value) || rangeMax;
            val = Math.min(rangeMax, Math.max(val, rangeMin));
            sliderMax.value = val;
            self.updatePriceRange(priceFilter);
          });
          maxInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              self.submitPrice(priceFilter);
            }
          });
        }

        if (applyBtn) {
          applyBtn.addEventListener('click', function() {
            self.submitPrice(priceFilter);
          });
        }
      });
    },

    /* Update price range bar visual */
    updatePriceRange: function(priceFilter) {
      var sliderMin = priceFilter.querySelector('[data-price-slider-min]');
      var sliderMax = priceFilter.querySelector('[data-price-slider-max]');
      var rangeDisplay = priceFilter.querySelector('[data-price-range]');

      if (!sliderMin || !sliderMax || !rangeDisplay) return;

      var min = parseInt(sliderMin.min);
      var max = parseInt(sliderMin.max);
      var minVal = parseInt(sliderMin.value);
      var maxVal = parseInt(sliderMax.value);

      var leftPercent = ((minVal - min) / (max - min)) * 100;
      var rightPercent = ((maxVal - min) / (max - min)) * 100;

      rangeDisplay.style.left = leftPercent + '%';
      rangeDisplay.style.width = (rightPercent - leftPercent) + '%';
    },

    /* Submit price filter - preserves current tag path.
       Works in the mobile drawer too: it has no footer "Apply" button, so the
       price filter's own Apply button navigates with the chosen range. */
    submitPrice: function(priceFilter) {
      var minInput = priceFilter.querySelector('[data-price-min-input]');
      var maxInput = priceFilter.querySelector('[data-price-max-input]');
      var minParam = priceFilter.dataset.minParam;
      var maxParam = priceFilter.dataset.maxParam;
      var rangeMin = parseInt(priceFilter.dataset.rangeMin) || 0;
      var rangeMax = parseInt(priceFilter.dataset.rangeMax) || 100000;
      var minVal = parseInt(minInput.value) || rangeMin;
      var maxVal = parseInt(maxInput.value) || rangeMax;

      var url = new URL(window.location.href);
      url.searchParams.delete(minParam);
      url.searchParams.delete(maxParam);
      url.searchParams.delete('page');

      if (minVal > rangeMin) url.searchParams.set(minParam, minVal);
      if (maxVal < rangeMax) url.searchParams.set(maxParam, maxVal);

      var qs = url.searchParams.toString();
      window.location.href = url.pathname + (qs ? '?' + qs : '');
    },

    /* Desktop mobile toggle */
    bindMobileEvents: function() {
      var self = this;

      document.querySelectorAll('[data-mobile-filters-toggle]').forEach(function(toggle) {
        toggle.addEventListener('click', function() { self.toggleMobileFilters(); });
      });

      document.querySelectorAll('[data-filters-close]').forEach(function(btn) {
        btn.addEventListener('click', function() { self.closeMobileFilters(); });
      });

      document.querySelectorAll('[data-filters-overlay]').forEach(function(overlay) {
        overlay.addEventListener('click', function() { self.closeMobileFilters(); });
      });
    },

    toggleMobileFilters: function() {
      if (this.filtersContainer) {
        this.filtersContainer.classList.toggle('is-open');
        document.body.classList.toggle('filters-open');
      }
    },

    closeMobileFilters: function() {
      if (this.filtersContainer) {
        this.filtersContainer.classList.remove('is-open');
        document.body.classList.remove('filters-open');
      }
      var sidebar = document.querySelector('[data-mobile-filter-sidebar]');
      var overlay = document.querySelector('[data-mobile-filter-overlay]');
      if (sidebar) sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('mobile-filters-open');
    },

    /* Mobile filter sidebar */
    initMobileFilterSidebar: function() {
      var self = this;

      document.querySelectorAll('[data-mobile-filter-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function() { self.openMobileFilters(); });
      });

      document.querySelectorAll('[data-mobile-filter-close]').forEach(function(btn) {
        btn.addEventListener('click', function() { self.closeMobileFilters(); });
      });

      document.querySelectorAll('[data-mobile-filter-overlay]').forEach(function(overlay) {
        overlay.addEventListener('click', function() { self.closeMobileFilters(); });
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') self.closeMobileFilters();
      });
    },

    openMobileFilters: function() {
      var sidebar = document.querySelector('[data-mobile-filter-sidebar]');
      var overlay = document.querySelector('[data-mobile-filter-overlay]');

      if (sidebar && sidebar.parentElement !== document.body) {
        document.body.appendChild(sidebar);
      }
      if (overlay && overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      if (sidebar) sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('mobile-filters-open');
    }
  };

  /* ============ Collection Filter (client-side, no page reload) ============ */
  const CollectionFilterHandler = {
    selectedCollections: [],

    init: function() {
      this.bindCheckboxEvents();
    },

    bindCheckboxEvents: function() {
      var self = this;
      document.addEventListener('click', function(e) {
        var label = e.target.closest('[data-collection-filter]');
        if (!label) return;

        e.preventDefault();
        e.stopPropagation();

        var checkbox = label.querySelector('.filter-list__checkbox');
        if (!checkbox) return;

        var text = label.querySelector('.filter-list__text');
        var collName = text ? text.textContent.trim() : '';
        if (!collName) return;

        var isActive = checkbox.dataset.filterActive === 'true';

        // Toggle state
        if (isActive) {
          checkbox.checked = false;
          checkbox.dataset.filterActive = 'false';
          label.classList.remove('filter-list__label--active');
          self.selectedCollections = self.selectedCollections.filter(function(c) { return c !== collName; });
        } else {
          checkbox.checked = true;
          checkbox.dataset.filterActive = 'true';
          label.classList.add('filter-list__label--active');
          if (self.selectedCollections.indexOf(collName) === -1) {
            self.selectedCollections.push(collName);
          }
        }

        // Filter products and update active tags
        self.applyFilter();
        self.updateActiveTags();
      });
    },

    applyFilter: function() {
      var productGrid = document.querySelector('.productgrid--items');
      if (!productGrid) return;

      var items = productGrid.querySelectorAll('[data-product-item]');
      if (!items.length) return;

      var selected = this.selectedCollections;
      var visibleCount = 0;

      items.forEach(function(item) {
        if (selected.length === 0) {
          item.style.display = '';
          visibleCount++;
          return;
        }

        var productCollections = (item.getAttribute('data-product-collections') || '').split('|||').map(function(c) {
          return c.trim();
        }).filter(function(c) { return c; });

        var matches = selected.some(function(sel) {
          return productCollections.indexOf(sel) !== -1;
        });

        if (matches) {
          item.style.display = '';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      });

      // Handle no results state
      var existingNoResults = productGrid.parentNode.querySelector('.productgrid--no-results-filtered');
      if (visibleCount === 0 && selected.length > 0) {
        if (!existingNoResults) {
          existingNoResults = document.createElement('div');
          existingNoResults.className = 'productgrid--no-results productgrid--no-results-filtered';
          existingNoResults.innerHTML = '<h2 class="productgrid--no-results-title">No products match your selected filters.</h2>' +
            '<a class="productgrid--no-results-button" href="' + window.location.pathname + '">Clear Filters</a>';
          productGrid.parentNode.insertBefore(existingNoResults, productGrid.nextSibling);
        }
        existingNoResults.style.display = '';
      } else if (existingNoResults) {
        existingNoResults.style.display = 'none';
      }
    },

    updateActiveTags: function() {
      var self = this;
      var filtersDiv = document.querySelector('.productgrid--filters');

      if (this.selectedCollections.length === 0) {
        // Remove the filters div if it was created by JS and no other tags exist
        if (filtersDiv && filtersDiv.dataset.collectionFilter === 'true') {
          filtersDiv.remove();
        }
        return;
      }

      // Create or get the filters div
      if (!filtersDiv) {
        filtersDiv = document.createElement('div');
        filtersDiv.className = 'productgrid--filters';
        filtersDiv.dataset.collectionFilter = 'true';
        // Insert before the productgrid--utils or productgrid--items
        var headerWrapper = document.querySelector('.collection--header-wrapper');
        var infoDiv = headerWrapper ? headerWrapper.querySelector('.collection--information') : null;
        if (infoDiv) {
          infoDiv.parentNode.insertBefore(filtersDiv, infoDiv.nextSibling);
        }
      }

      // Build the tag list
      var html = '<ul class="filter-group--grid">';
      this.selectedCollections.forEach(function(collName) {
        html += '<li class="filter-item--grid">' +
          '<a href="#" class="active-tag" data-remove-collection="' + collName.replace(/"/g, '&quot;') + '">' +
          '<span class="filter-text">' + collName + '</span>' +
          '<span class="filter-icon--remove">' +
          '<svg aria-hidden="true" focusable="false" role="presentation" width="12" height="12" viewBox="0 0 12 12"><path d="M10 2L2 10M2 2l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '<span class="visually-hidden">Remove filter</span>' +
          '</span></a></li>';
      });

      if (this.selectedCollections.length > 1) {
        html += '<li class="filter-item--grid-simple"><a href="#" data-remove-all-collections>Remove All</a></li>';
      }

      html += '</ul>';
      filtersDiv.innerHTML = html;

      // Bind remove click events
      filtersDiv.querySelectorAll('[data-remove-collection]').forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var name = link.getAttribute('data-remove-collection');
          self.selectedCollections = self.selectedCollections.filter(function(c) { return c !== name; });

          // Uncheck sidebar checkbox
          document.querySelectorAll('[data-filter-group="collection"] [data-collection-filter]').forEach(function(label) {
            var text = label.querySelector('.filter-list__text');
            if (text && text.textContent.trim() === name) {
              var cb = label.querySelector('.filter-list__checkbox');
              if (cb) { cb.checked = false; cb.dataset.filterActive = 'false'; }
              label.classList.remove('filter-list__label--active');
            }
          });

          self.applyFilter();
          self.updateActiveTags();
        });
      });

      var removeAll = filtersDiv.querySelector('[data-remove-all-collections]');
      if (removeAll) {
        removeAll.addEventListener('click', function(e) {
          e.preventDefault();
          self.selectedCollections = [];
          document.querySelectorAll('[data-filter-group="collection"] [data-collection-filter]').forEach(function(label) {
            var cb = label.querySelector('.filter-list__checkbox');
            if (cb) { cb.checked = false; cb.dataset.filterActive = 'false'; }
            label.classList.remove('filter-list__label--active');
          });
          self.applyFilter();
          self.updateActiveTags();
        });
      }
    }
  };

  /* ============ Vendor Tag Fallback ============ */
  /* When a vendor is in the URL as a tag but no products have that tag,
     fetch the unfiltered collection page and show products matching the vendor */
  const VendorTagFallback = {
    init: function() {
      var grid = document.querySelector('[data-vendor-fallback-grid]');
      if (!grid) return;

      var collectionUrl = grid.getAttribute('data-collection-url');
      var currentTags = grid.getAttribute('data-current-tags') || '';
      var tagList = currentTags.split('|||').filter(function(t) { return t.length > 0; });

      if (!collectionUrl || tagList.length === 0) return;

      // Show skeleton cards immediately so the grid isn't blank during fetch.
      var skeletonHtml = '';
      for (var sk = 0; sk < 6; sk++) {
        skeletonHtml += '<li class="productgrid--item dpref-skeleton" aria-hidden="true">' +
          '<div class="dpref-skeleton__image"></div>' +
          '<div class="dpref-skeleton__line dpref-skeleton__line--title"></div>' +
          '<div class="dpref-skeleton__line dpref-skeleton__line--price"></div>' +
          '<div class="dpref-skeleton__line dpref-skeleton__line--btn"></div>' +
          '</li>';
      }
      grid.innerHTML = skeletonHtml;
      if (!document.getElementById('dpref-skeleton-style')) {
        var skStyle = document.createElement('style');
        skStyle.id = 'dpref-skeleton-style';
        skStyle.textContent =
          '.dpref-skeleton{list-style:none;padding:12px;border:1px solid #eee;border-radius:8px;background:#fff;}' +
          '.dpref-skeleton__image{aspect-ratio:1/1;background:#eee;border-radius:6px;margin-bottom:12px;}' +
          '.dpref-skeleton__line{height:12px;background:#eee;border-radius:4px;margin:8px 0;}' +
          '.dpref-skeleton__line--title{width:90%;height:14px;}' +
          '.dpref-skeleton__line--price{width:40%;height:16px;}' +
          '.dpref-skeleton__line--btn{width:100%;height:36px;margin-top:14px;}' +
          '.dpref-skeleton__image,.dpref-skeleton__line{position:relative;overflow:hidden;}' +
          '.dpref-skeleton__image::after,.dpref-skeleton__line::after{' +
            'content:"";position:absolute;inset:0;' +
            'background:linear-gradient(90deg,transparent,rgba(255,255,255,.6),transparent);' +
            'transform:translateX(-100%);animation:dprefShimmer 1.2s infinite;' +
          '}' +
          '@keyframes dprefShimmer{100%{transform:translateX(100%);}}';
        document.head.appendChild(skStyle);
      }

      // Use Shopify's Section Rendering API when available — fetches just the
      // collection section HTML instead of the full page. Much smaller, faster.
      var sectionWrapper = grid.closest('.shopify-section');
      var sectionId = sectionWrapper ? sectionWrapper.id.replace(/^shopify-section-/, '') : '';
      var fetchUrl = sectionId
        ? collectionUrl + (collectionUrl.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sectionId)
        : collectionUrl;

      // Fetch the unfiltered collection page HTML
      fetch(fetchUrl)
        .then(function(res) { return sectionId ? res.json() : res.text(); })
        .then(function(payload) {
          // Section API returns { "<id>": "<html>" }; fall back to plain HTML.
          var html = sectionId ? (payload[sectionId] || '') : payload;
          if (!html) {
            // Section API returned nothing — retry once with full-page fetch.
            return fetch(collectionUrl).then(function(r) { return r.text(); });
          }
          return html;
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Restore sidebar filters from unfiltered page
          var currentFilters = document.querySelector('[data-collection-filters]');
          var fetchedFilters = doc.querySelector('[data-collection-filters]');
          if (currentFilters && fetchedFilters) {
            currentFilters.innerHTML = fetchedFilters.innerHTML;

            // Mark the active vendor and hide non-selected vendors
            currentFilters.querySelectorAll('[data-filter-group="vendor"] .filter-list__item').forEach(function(item) {
              var link = item.querySelector('a[data-tag-filter]');
              if (!link) return;
              var linkText = (link.querySelector('.filter-list__text') || {}).textContent || '';
              var linkHandle = linkText.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
              var isActive = false;
              for (var i = 0; i < tagList.length; i++) {
                var tagHandle = tagList[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
                if (linkHandle === tagHandle) {
                  isActive = true;
                  break;
                }
              }
              if (isActive) {
                link.classList.add('filter-list__label--active');
                // Update link to remove vendor (go back to unfiltered)
                link.setAttribute('href', collectionUrl);
              } else {
                // Hide non-selected vendors
                item.style.display = 'none';
              }
            });

            // Prepend the active URL handles (vendor) to non-vendor tag links
            // so clicking a tag preserves the vendor selection. Also mark
            // active tags so checkboxes light up to match the URL chips.
            var activeHandlesArr = tagList.map(function(t) {
              return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            }).filter(Boolean);
            var activeSegment = activeHandlesArr.join('+');
            var activeHandlesSet = {};
            activeHandlesArr.forEach(function(h) { activeHandlesSet[h] = true; });

            if (activeSegment) {
              var collP = collectionUrl.replace(/\/+$/, '') + '/';
              currentFilters.querySelectorAll('[data-filter-group]:not([data-filter-group="vendor"]) a[data-tag-filter]').forEach(function(link) {
                var href = link.getAttribute('href') || '';
                if (href.indexOf(collP) !== 0) return;
                var rest = href.slice(collP.length);
                var qsIdx = rest.indexOf('?');
                var path = qsIdx === -1 ? rest : rest.slice(0, qsIdx);
                var qs = qsIdx === -1 ? '' : rest.slice(qsIdx);
                if (!path) return;

                // The path is this link's own handle (parent's sidebar has one
                // handle per link). If it's already in the active URL, mark
                // active and rewrite to "remove" it; otherwise prepend vendor.
                var ownHandle = path.toLowerCase();
                if (activeHandlesSet[ownHandle]) {
                  link.classList.add('filter-list__label--active');
                  // Build URL without this handle
                  var remaining = activeHandlesArr.filter(function(h) { return h !== ownHandle; });
                  var newSeg = remaining.join('+');
                  link.setAttribute('href', collP.replace(/\/$/, '') + (newSeg ? '/' + newSeg : '') + qs);
                } else {
                  link.setAttribute('href', collP + activeSegment + '+' + path + qs);
                }
              });
            }

            // Re-init price sliders after restoring filters
            CollectionFilters.initPriceSliders();
          }

          var allProducts = doc.querySelectorAll('[data-product-item]');
          var matched = [];
          var matchedVendorName = '';

          // For each tag, check if it matches a product vendor
          allProducts.forEach(function(product) {
            var vendor = (product.getAttribute('data-product-vendor') || '').toLowerCase().trim();
            var vendorHandle = vendor.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

            for (var i = 0; i < tagList.length; i++) {
              var tagHandle = tagList[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
              if (vendorHandle === tagHandle || vendor === tagList[i].toLowerCase()) {
                matched.push(product.outerHTML);
                if (!matchedVendorName) {
                  matchedVendorName = product.getAttribute('data-product-vendor') || '';
                }
                break;
              }
            }
          });

          // Fix collection title: replace "to {vendor}" with "by {Vendor}"
          if (matchedVendorName) {
            var titleEl = document.querySelector('.collection--title');
            if (titleEl) {
              var baseTitle = doc.querySelector('.collection--title');
              var baseTitleText = baseTitle ? baseTitle.textContent.trim() : '';
              if (baseTitleText) {
                titleEl.textContent = baseTitleText + ' by ' + matchedVendorName;
              }
            }
          }

          if (matched.length > 0) {
            grid.innerHTML = matched.join('');
            // Re-init any product JS (quick shop, etc.)
            if (window.theme && window.theme.ProductGridItem) {
              grid.querySelectorAll('[data-product-item]').forEach(function(item) {
                new window.theme.ProductGridItem(item);
              });
            }
            // rimg-rendered <img> tags have a transparent SVG srcset that wins
            // until rimg's IntersectionObserver promotes them. Since we just
            // injected the DOM, that observer never sees these elements.
            // Strip srcset so the browser falls back to the real src URL.
            grid.querySelectorAll('img[data-rimg="lazy"]').forEach(function(img) {
              img.removeAttribute('srcset');
              img.setAttribute('data-rimg', 'loaded');
            });
            grid.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
          } else {
            // No vendor matches — show no results
            var noResults = document.querySelector('[data-vendor-fallback-no-results]');
            if (noResults) noResults.style.display = '';
            grid.style.display = 'none';
          }
        })
        .catch(function() {
          var noResults = document.querySelector('[data-vendor-fallback-no-results]');
          if (noResults) noResults.style.display = '';
          grid.style.display = 'none';
        });
    }
  };

  function initCollectionFilters() {
    CollectionFilters.init();
    CollectionFilterHandler.init();
    VendorTagFallback.init();

    // The desktop filter sidebar (.productgrid--sidebar) is display:none on mobile,
    // where the .mobile-filter-sidebar drawer handles filtering instead. Remove the
    // now-redundant desktop sidebar from the mobile DOM to cut DOM weight. Done AFTER
    // init so the price slider (whose init gates on the sidebar being present) is
    // already bound; the mobile drawer is a separate element and is untouched.
    if (window.matchMedia('(max-width: 991px)').matches) {
      var desktopSidebar = document.querySelector('.productgrid--sidebar');
      if (desktopSidebar) desktopSidebar.remove();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }

  window.CollectionFilters = CollectionFilters;
})();
